import { Descriptions, Tag } from 'antd';
import type { UserListItem } from '../users.api';

/** Read-only: roles are edited from the list, where the role catalogue is already loaded. */
export function UserDetailsPanel({ user }: { user: UserListItem }) {
  return (
    <Descriptions column={{ xs: 1, md: 2 }} bordered>
      <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
      <Descriptions.Item label="Phone">{user.phone ?? '—'}</Descriptions.Item>
      <Descriptions.Item label="Roles">{user.roles.length > 0 ? user.roles.map((role) => <Tag key={role}>{role}</Tag>) : '—'}</Descriptions.Item>
      <Descriptions.Item label="Status">
        <Tag color={user.isActive ? 'success' : 'default'}>{user.isActive ? 'Active' : 'Inactive'}</Tag>
      </Descriptions.Item>
      <Descriptions.Item label="Last login">{user.lastLoginAt ? new Date(user.lastLoginAt).toLocaleString() : 'Never'}</Descriptions.Item>
    </Descriptions>
  );
}
